import actions from './actions';
import {act} from "@testing-library/react";

const initState = {
    statistics   : {
        data: []
    },
    loading : false,
    message: null,
    type: null
};

export default function layout(state = initState, action) {
    switch (action.type) {
        case actions.FETCH_TOTAL_REVENUE_REQUESTED:
        case actions.FETCH_ANALYTICS_REQUESTED:
            return {
                ...state,
                statistics   : {
                    data: []
                },
                loading : true
            };
        case actions.FETCH_ANALYTICS_SUCCEEDED:
            return {
                ...state,
                loading: false,
                statistics: action.statistics
            };
        case actions.FETCH_ANALYTICS_FAILED:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}
